import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { Alert } from '../components/ui/alert';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const Profile: React.FC = () => {
  const { t } = useLanguage();
  const { user, fetchProfile, isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadProfile = async () => {
      if (isAuthenticated) {
        setIsLoading(true);
        setError(null);
        try {
          await fetchProfile();
        } catch (err) {
          setError(err instanceof Error ? err.message : t('failedToLoadProfile'));
        } finally {
          setIsLoading(false);
        }
      }
    };

    loadProfile();
  }, [isAuthenticated, fetchProfile, t]);

  if (!isAuthenticated) {
    return (
      <Alert variant="destructive">{t('pleaseLoginToViewProfile')}</Alert>
    );
  }

  if (isLoading) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl py-4">
        <h1>{t('myProfile')}</h1>
        <p className="mb-4 text-sm text-muted-foreground">{t('viewPersonalInfo')}</p>

        {error && <Alert variant="destructive" className="mb-4">{error}</Alert>}

        <Card className="rounded-none">
          <CardHeader><CardTitle>{t('myProfile')}</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div className="grid gap-4 sm:grid-cols-2">
              <div><Label>{t('name')}</Label><Input value={user?.name || ''} readOnly /></div>
              <div><Label>{t('surname')}</Label><Input value={user?.surname || ''} readOnly /></div>
            </div>
            <div><Label>{t('emailAddress')}</Label><Input value={user?.email || ''} readOnly /></div>
            <div><Label>{t('phoneNumber')}</Label><Input value={user?.phone || ''} readOnly placeholder="+994 12 345 67 89" /></div>
            <div>
              <Label>{t('finCode')}</Label>
              <Input value={user?.fin || ''} readOnly maxLength={7} />
              <p className="mt-1 text-xs text-muted-foreground">{t('finCodeHelper')}</p>
            </div>
          </CardContent>
        </Card>
    </div>
  );
};

export default Profile;

